import React, { useState, useEffect } from "react";
import { API_BASE } from "../../api/config";

const API = `${API_BASE}/ki`;

const ORDNER_OPTIONEN = [
  { key: "NOK", label: "NOK (Fehler)" },
  { key: "Fehler", label: "Batch Fehler" },
  { key: "Output", label: "Batch Output" },
];

export default function DateiBrowser({ onFileSelect }) {
  const [folder, setFolder] = useState("NOK");
  const [subfolder, setSubfolder] = useState("");
  const [files, setFiles] = useState([]);
  const [subfolders, setSubfolders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    ladeOrdner(folder, subfolder);
  }, [folder]);

  const ladeOrdner = async (f, sub = "") => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams({ folder: f });
      if (sub) params.set("subfolder", sub);
      const res = await fetch(`${API}/lern/browse?${params}`);
      const data = await res.json();
      setFiles(data.files || []);
      setSubfolders(data.subfolders || []);
      if (!data.exists) setError("Ordner nicht gefunden oder leer.");
    } catch (e) {
      setError("Verbindungsfehler: " + e.message);
    }
    setLoading(false);
  };

  const oeffneSubfolder = (sub) => {
    const neuerPfad = subfolder ? `${subfolder}/${sub.name}` : sub.name;
    setSubfolder(neuerPfad);
    ladeOrdner(folder, neuerPfad);
  };

  const zurueck = () => {
    const teile = subfolder.split("/");
    teile.pop();
    const neu = teile.join("/");
    setSubfolder(neu);
    ladeOrdner(folder, neu);
  };

  const waehleFile = async (file) => {
    setSelected(file.path);
    if (!onFileSelect) return;
    // Datei-Infos laden
    try {
      const res = await fetch(`${API}/lern/file-info`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dropbox_path: file.path }),
      });
      const info = await res.json();
      onFileSelect({ ...file, ...info });
    } catch (e) {
      onFileSelect(file);
    }
  };

  return (
    <div className="datei-browser">
      <div className="datei-browser-header">
        <div className="folder-tabs">
          {ORDNER_OPTIONEN.map((o) => (
            <button
              key={o.key}
              className={`folder-tab ${folder === o.key ? "active" : ""}`}
              onClick={() => { setFolder(o.key); setSubfolder(""); }}
            >
              {o.label}
            </button>
          ))}
        </div>
        {subfolder && (
          <button className="zurueck-btn" onClick={zurueck}>
            ← Zurück
          </button>
        )}
        <span className="pfad-anzeige">/{subfolder || ""}</span>
      </div>

      {loading && <div className="browser-loading">Lade...</div>}
      {error && <div className="browser-error">{error}</div>}

      <div className="datei-liste">
        {subfolders.map((sub) => (
          <div
            key={sub.name}
            className="datei-eintrag ordner"
            onClick={() => oeffneSubfolder(sub)}
          >
            📁 {sub.name}
          </div>
        ))}
        {files.map((file) => (
          <div
            key={file.path}
            className={`datei-eintrag pdf ${selected === file.path ? "selected" : ""} ${
              file.name.includes("###") || file.name.includes("???") ? "has-error" : ""
            }`}
            onClick={() => waehleFile(file)}
          >
            <span className="datei-icon">📄</span>
            <span className="datei-name">{file.name}</span>
            <span className="datei-size">{(file.size / 1024).toFixed(0)} KB</span>
          </div>
        ))}
        {!loading && files.length === 0 && subfolders.length === 0 && (
          <div className="browser-leer">Keine PDF-Dateien in diesem Ordner.</div>
        )}
      </div>
    </div>
  );
}
